import { render, staticRenderFns } from "./LeaveLimit.vue?vue&type=template&id=245fd42d"
import script from "./LeaveLimit.vue?vue&type=script&lang=js"
export * from "./LeaveLimit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports